import clearFormFields from "@partials/UI/form/modules/clearFormFields";
import * as notificationsModule from "@partials/UI/notifications/notifications";
import { feedbackModal } from "@partials/UI/feedback/modal/modal";

const formAction = PAGES_CONFIG.telegramPHPFile;
let goalSent = false;

// ОТПРАВКА ФОРМЫ
export default async function sendForm(form, token = null) {
    try {
        goalSent = false;

        const formData = new FormData(form);
        if (token) formData.append("g-recaptcha-response", token);

        try {
            const response = await fetch(formAction, {
                method: form.method || "POST",
                body: formData,
                signal: AbortSignal.timeout(30000),
            });

            // Парсим JSON ответ
            const result = await response.json();

            // Проверяем поле "ok" в JSON ответе, а не HTTP статус
            if (result.ok === true) {
                handleSuccess(form);
                return true;
            } else {
                handleError(form);
                return false;
            }
        } catch (error) {
            handleError(form);
            return false;
        }
    } catch (error) {
        // Критическая защита - если все сломалось
        try {
            showNotification("error");
        } catch {}
        return false;
    }
}

// ОБРАБОТКА УСПЕХА
function handleSuccess(form) {
    // Яндекс.Метрика
    if (typeof ym !== "undefined" && !goalSent) {
        ym(106076912,'reachGoal','successSendForm')
        goalSent = true;
    }

    closeFeedbackModal();
    clearFormFields(form);
    showNotification("success");
}

// ОБРАБОТКА ОШИБКИ
function handleError(form) {
    showNotification("error");
}

// УВЕДОМЛЕНИЯ
function showNotification(type) {
    const config = type === "success" ? notificationsModule.successForm : notificationsModule.unsuccessForm;

    notificationsModule.createInstanceNotification(config).open();
}

// ЗАКРЫТИЕ МОДАЛЬНОГО ОКНА
function closeFeedbackModal() {
    try {
        if (feedbackModal?.close) feedbackModal.close();
    } catch (error) {
        // Тихо игнорируем ошибки
    }
}

export { showNotification, closeFeedbackModal };
